import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "dropdown-container" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "search-container" }
const _hoisted_4 = { class: "search-box" }
const _hoisted_5 = { class: "icon" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "search-header" }
const _hoisted_9 = { class: "search-container" }
const _hoisted_10 = { class: "search-box" }
const _hoisted_11 = { class: "icon" }
const _hoisted_12 = ["placeholder"]
const _hoisted_13 = { class: "mobile-country-list-wrapper" }
const _hoisted_14 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchIcon = _resolveComponent("SearchIcon")!
  const _component_CloseIcon = _resolveComponent("CloseIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "dropdown-button",
      style: _normalizeStyle({ width: _ctx.showCountryName ? '100%' : 'auto' }),
      type: "button",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isDropdownOpen = !_ctx.isDropdownOpen))
    }, [
      _createElementVNode("span", {
        class: _normalizeClass(["flag", [_ctx.userSelectedCountry ? `flag:${_ctx.userSelectedCountry?.code}` : '']])
      }, null, 2),
      (_ctx.showCountryName)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.userSelectedCountry ? _ctx.userSelectedCountry?.name : _ctx.$t('countrySelector.selectCountry')), 1))
        : _createCommentVNode("", true),
      _cache[4] || (_cache[4] = _createElementVNode("span", { class: "caret" }, null, -1))
    ], 4),
    (_ctx.isDropdownOpen && !_ctx.isMobile)
      ? (_openBlock(), _createElementBlock("ul", {
          key: 0,
          class: "dropdown-list",
          style: _normalizeStyle({
        width: _ctx.dropdownWidth,
        left: _ctx.dropdownLeft + 'px',
        top: _ctx.dropdownLeft === 0 ? undefined : 2 + 'rem',
      })
        }, [
          _createElementVNode("li", null, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, [
                  _createVNode(_component_SearchIcon)
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  placeholder: _ctx.$t('countrySelector.selectCountry'),
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchQuery) = $event)),
                  autofocus: "",
                  autocomplete: "off"
                }, null, 8, _hoisted_6), [
                  [_vModelText, _ctx.searchQuery]
                ])
              ])
            ])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredCountries, (country) => {
            return (_openBlock(), _createElementBlock("li", {
              key: country.code,
              onClick: ($event: any) => (_ctx.selectCountry(country))
            }, [
              _createElementVNode("span", {
                class: _normalizeClass(["flag", [country ? `flag:${country.code}` : '']])
              }, null, 2),
              _createElementVNode("span", null, _toDisplayString(country.name) + " (+" + _toDisplayString(country.prefix) + ")", 1)
            ], 8, _hoisted_7))
          }), 128))
        ], 4))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["mobile-dropdown", { show: _ctx.isDropdownOpen && _ctx.isMobile }])
    }, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.$t('countrySelector.selectCountry')), 1),
        _createElementVNode("button", {
          type: "button",
          "aria-label": "back-sheet",
          class: "close-button",
          onClick: _cache[2] || (_cache[2] = ($event: any) => {
            _ctx.isDropdownOpen = false;
            _ctx.searchQuery = '';
          })
        }, [
          _createVNode(_component_CloseIcon)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("span", _hoisted_11, [
            _createVNode(_component_SearchIcon)
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            placeholder: _ctx.$t('countrySelector.selectCountry'),
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchQuery) = $event)),
            autofocus: "",
            autocomplete: "off"
          }, null, 8, _hoisted_12), [
            [_vModelText, _ctx.searchQuery]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredCountries, (country) => {
            return (_openBlock(), _createElementBlock("li", {
              key: country.code,
              onClick: ($event: any) => (_ctx.selectCountry(country))
            }, [
              _createElementVNode("span", {
                class: _normalizeClass(["flag", [country ? `flag:${country.code}` : '']])
              }, null, 2),
              _createElementVNode("span", null, _toDisplayString(country.name) + " (+" + _toDisplayString(country.prefix) + ")", 1)
            ], 8, _hoisted_14))
          }), 128))
        ])
      ])
    ], 2)
  ]))
}